export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            locations: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        locations(state) {
            return state.locations.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setLocation(state, locations) {
            state.locations = locations
        },
    },

    actions: {
        async getLocations(context, payload) {
            context.commit('setLoading', true);
        
            await axios.post(`${this.state.host}/get-locations`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setLocation', res.data.locations);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveLocation(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-location';
            } else {
                url = 'add-location';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getLocations');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteLocation(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-location/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getLocations');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}